import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GateLightBoxData } from '../../../../buyer';
import { CancelCreditPaymentService } from '../../../../services/cancel-credit-payment.service';
import { UpdateTrxRefNumService } from '../../../../services/update-trx-ref-num.service';
import Swal from 'sweetalert2';
import axios from 'axios';

@Component({
  selector: 'app-new-gate-lightbox',
  templateUrl: './new-gate-lightbox.component.html',
  styleUrls: ['./new-gate-lightbox.component.scss'],
})
export class NewGateLightboxComponent implements OnInit {
  requestUrl: string =
    'https://pay.easykash.net/backend/lightbox/transactionRequest';
  inquireUrl: string =
    'https://pay.easykash.net/backend/lightbox/inquire-status';
  isLightBoxNotRun: boolean = true;
  isLightBoxCanceled: boolean = false;
  isLightBoxExpired: boolean = false;
  isLightBoxClosedAfterRequest: boolean = false;
  failReason: string = '';
  refNum: any;

  constructor(
    private router: Router,
    private updateTrxRefNum: UpdateTrxRefNumService,
    private cancelCreditPaymentService: CancelCreditPaymentService
  ) {}

  async ngOnInit() {}

  async openLightBox(data: GateLightBoxData) {
    this.isLightBoxNotRun = true;
    this.isLightBoxCanceled = false;
    this.isLightBoxExpired = false;
    this.refNum = data.trxRefNum;
    this.isLightBoxClosedAfterRequest = false;
    await this.lightBox(
      data,
      async (response: any) => {
        if (response == 'closeLightbox' && this.isLightBoxNotRun) {
          return;
        } else {
          if (response.isLightBoxCanceled && !this.isLightBoxExpired) {
            await this.cancelPayment(data, 'CANCELED');
          }
        }
        await this.updateRequest(data, response);
      },
      async (error: any) => {
        console.log('error: ', error);
        this.router.navigate(['gate'], {
          queryParams: {
            refNum: this.refNum,
            card: 1,
          },
        });
      }
    );
    await this.makeLightboxExpired(data, 'EXPIRED');
    return { done: true };
  }

  /**
   *
   * @param {*} data
   * @param {*} successCallBack
   * @param {*} errorCallBack
   */
  async lightBox(
    data: GateLightBoxData,
    successCallBack: any,
    errorCallBack: any
  ) {
    if (this.isLightBoxNotRun) {
      this.isLightBoxNotRun = false;
      this.isLightBoxCanceled = false;
      this.isLightBoxExpired = false;
      this.isLightBoxClosedAfterRequest = false;
      this.failReason = '';
      try {
        this.openIframe(
          data.url,
          successCallBack,
          data.trxRefNum
        );
        this.loadStyle(`
                .swal2-popup{
                    background: #fff0 !important;
                    width: 100%;
                }
                .swal2-actions{
                    display: none !important;
                }
                body > div.swal2-container.swal2-center.swal2-backdrop-show > div > div.swal2-header > button{
                    margin-top: 0.5rem;
                    position: absolute;
                    background: #FFF;
                    top: 1rem;
                    left: 48.8%;
                    border: 3px;
                    border-radius: 50%
                }
            `);
        let interval = setInterval(() => {
          if (
            this.isLightBoxNotRun ||
            this.isLightBoxCanceled ||
            this.isLightBoxExpired
          ) {
            successCallBack('closeLightbox');
            clearInterval(interval);
          }
          axios
            .get(this.inquireUrl + '?refNum=' + data.merchant_ref_num, {
              headers: {
                clientid: data.clientid,
              },
            })
            .then((res: any) => {
              if (
                res &&
                res.data.status != 'PENDING' &&
                res.data.status != 'REDEEMED'
              ) {
                this.isLightBoxClosedAfterRequest = true;
                this.failReason = res.data.reason;
                //@ts-ignore
                document.getElementsByClassName('swal2-close')[0].click();
                if (res.data.status != 'CANCELED') {
                  this.isLightBoxCanceled = false;
                }
                this.router.navigate(['gate'], {
                  queryParams: {
                    refNum: this.refNum,
                    reason: res.reason,
                    card: 1,
                  },
                });
                successCallBack({
                  trxRefNum: data.trxRefNum,
                  merchant_ref_num: data.merchant_ref_num,
                  isLightBoxCanceled: this.isLightBoxCanceled,
                  isLightBoxExpired: this.isLightBoxExpired,
                });
                clearInterval(interval);
              }
            });
        }, 5000);
      } catch (e) {
        if (data.debug) {
          this.showError(e.response.data.message);
        }
        errorCallBack(e.response.data);
      }
    }
  }

  openIframe(
    url: any,
    successCallBack: any,
    trxRefNum: any
  ) {
    window.addEventListener('message', (e) => {
      console.log(e);
    });

    Swal.fire({
      html: `
        <iframe src="${url}" width="390px" id="otpFrame" height="560px" frameborder="0"></iframe>
        `,
      showCloseButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      successCallBack({
        trxRefNum,
        reason: this.failReason,
      });
    });

    var payButton = document.getElementById('pay');
    if (payButton) {
      payButton.setAttribute('disabled', 'disabled');
    }
  }

  async updateRequest(data: GateLightBoxData, response: any) {
    try {
      this.updateTrxRefNum.setParams({
        refNum: data.providerRefNum,
        trxRefNum: response.trxRefNum,
      });
      await this.updateTrxRefNum.make();
    } catch (error) {
      await this.updateRequest(data, response);
    }
  }

  /**
   * cancel payment and update its status and reason for failure
   * @param data
   * @param status
   */
  async cancelPayment(data: GateLightBoxData, status: string) {
    try {
      this.cancelCreditPaymentService.setParams({
        refNum: data.trxRefNum,
        status,
        merchant_ref_num: data.merchant_ref_num,
      });
      await this.cancelCreditPaymentService.make();
    } catch (error) {
      console.log('error: ', error);
    }
  }

  /**
   * Make lightbox expire after 1 hour
   * @param data
   * @param status
   */
  async makeLightboxExpired(data: GateLightBoxData, status: string) {
    await this.sleep(1000 * 60 * 60);
    if (!this.isLightBoxCanceled) {
      this.closeLightboxAfterExpiration();
      await this.cancelPayment(data, status);
    }
  }

  /**
   * This function is used to handle async settimeout calls
   * @param ms time out in milli seconds
   */
  async sleep(ms: any) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  showError(message: any) {
    if (typeof Swal !== 'undefined') {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: message,
      });
    } else {
      alert(message);
    }
  }

  loadStyle(style: any) {
    var styleObject = document.createElement('style');
    styleObject.innerHTML = style;
    document.head.appendChild(styleObject);
  }

  closeLightboxAfterExpiration() {
    let swalCloseButton = document.getElementsByClassName('swal2-close');
    this.isLightBoxNotRun = true;
    if (swalCloseButton && swalCloseButton[0]) {
      this.isLightBoxExpired = true;
      this.isLightBoxCanceled = false;
      //@ts-ignore
      swalCloseButton[0].click();
    }
    this.router.navigate(['gate'], {
      queryParams: {
        refNum: this.refNum,
        card: 1,
      },
    });
  }
}
